import React, { useState } from "react";

import { actions } from "../../actions";
import { Link,  useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Button, Empty } from "antd";

import "./footer.css";


function Footer (props)  {

  const navigate = useNavigate();

  const handleContact = () =>{
    navigate('/qhrflowcontact')
  }
  const handleHome = () =>{
    navigate('/home')
  }  
  return (
    <div className="footer-quallyhireai-wrapper">

      <div className="footer-content">

        <div className="footer-section">
          <div className="footer-title" onClick={handleHome}>
            QuallyHire AI
          </div>

          <div className="footer-description">
            AI-powered hiring platform for smarter, faster recruitment.
          </div>

          <Button
            type="primary"
            shape="round"
            className="footer-demo-button"
            onClick={handleContact}
          >
            Book a Demo
          </Button>
        </div>


        <div className="footer-section">
          <div className="footer-title">
            Platform
          </div>

          <Link to="/qhrflow">QHRFlow</Link>
          <Link to="/nujobs">NuJobs</Link>          
          <Link to="/qhrset">QHRSET Evaluation Platform</Link>
        </div>


        <div className="footer-section">
          <div className="footer-title">
            Company
          </div>

          <Link to="/aboutus">About Us</Link>
          <Link to="/qhrflowcontact">Contact Us</Link>
        </div>


        <div className="footer-section">
          <div className="footer-title">
            Legal
          </div>

          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/terms-conditions">Terms & Conditions</Link>
          <Link to="/cookie-policy">Cookie Policy</Link>
          <Link to="/disclaimer">Disclaimer</Link>
        </div>

      </div>


      <div className="footer-bottom">

        <div className="footer-menu">
          © 2026–2027 HMW Communications Private Limited
        </div>

        <div className="footer-product">
          QuallyHire AI
        </div>

      </div>

    </div>
  );
};

export default Footer;
